import { useState } from "react";
import ReassignDriver from "../../../../../Modal/ReassignDriver";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../../../redux/reducers/loader";
import * as Apis from "../../../../../utils/helper/enum";
import globalRequest from "../../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { changeDateFormate, checkPermissionAction, convertSlote } from "../../../../../utils/helper/utils";
const DriverDetail = ({ orderId, driverDetails, status, reloadPage, deliveryType, driver_pickup_time, deliveryDate, permissionJson }) => {
  const dispatch = useDispatch();
  const [isReassignDriverModalOpen, setIsReassignDriverModalOpen] = useState(false);
  const showReassignDriverModal = () => {
    setIsReassignDriverModalOpen(true);
  };
  const handleReassignDriverOk = async (driverId, driverSloteId) => {
    dispatch(changeLoader(true));
    let response = await globalRequest(
      Apis?.ORDERS?.ASSIGN_TO_DRIVER + "/" + orderId,
      "post",
      {
        driver_id: driverId,
        driver_time_slot_id: deliveryType === "schedule" ? driverSloteId : 0,
      },
      {},
      true
    );
    let apiResponse = response?.data;
    if (response?.status === 200) {
      let msg = "Driver successfully assign";
      toast.success(msg, {
        duration: 2000,
      });
      reloadPage();
      setIsReassignDriverModalOpen(false);
    } else {
      toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };
  const handleReassignDriverCancel = () => {
    setIsReassignDriverModalOpen(false);
  };
  return (
    <>
      <div className="px-9 py-5  border-gray-250 border-b w-full ">
        <h2 className="font-semibold text-base mb-3">Driver Detail</h2>
        <div className="flex">
          <div className="">
            {Object.keys(driverDetails).length > 0 && (
              <>
                <div className="flex">
                  <img src="images/side-bar-icons.png" alt="side-bar-icons" className="w-[24px] h-[24px] rounded" />
                  <h3 className="text-sm font-semibold pl-2">
                    {driverDetails?.driverName} | <span className=" font-normal text-[#222222]">{driverDetails?.mobileNo}</span>
                    {driver_pickup_time !== 0 ? (
                      <span className=" font-normal text-[#222222]">
                        | <strong>Pickup Date & Time</strong> : {changeDateFormate(deliveryDate)}
                        {/* {deliveryType === "fastest"
                          ? " (ASAP)"
                          : `at ${convertSlote(
                              driverDetails?.driverTimeSlot[0]?.from
                            )}`} */}
                        {` at ${convertSlote(driver_pickup_time)}`}
                      </span>
                    ) : null}
                  </h3>
                </div>
                <p className=" text-sm pt-[4px] text-[#222222]">{driverDetails?.address}</p>
              </>
            )}
            {checkPermissionAction("Order Management", permissionJson, "assign_driver") && status && status === "ready_to_pick" ? (
              <h2 className="underline text-base my-2 cursor-pointer" onClick={showReassignDriverModal}>
                {Object.keys(driverDetails).length > 0 ? "Reassign Driver" : "Assign Driver"}
              </h2>
            ) : null}
          </div>
        </div>
      </div>
      {isReassignDriverModalOpen && (
        <ReassignDriver
          isOpen={isReassignDriverModalOpen}
          onOk={handleReassignDriverOk}
          onCancel={handleReassignDriverCancel}
          orderId={orderId}
        />
      )}
    </>
  );
};
export default DriverDetail;
